/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    ACCORDION
\*------------------------------------*/
class Accordion {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('[data-accordion-trigger]');
        self.panel = self.elem.querySelector('[data-accordion-panel]');
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            if(self.isOpen) {
                // Close it
                self.close();
            } else {
                // Open it
                self.open();
            }
        });

        if(self.elem.hasAttribute('data-accordion-open')) {
            self.open(0);
        }
    }

    open(duration = 400) {
        let self = this;

        self.trigger.setAttribute('aria-expanded', true);
        $(self.panel).slideDown(duration);

        self.isOpen = true;
    }

    close(duration = 400) {
        let self = this;

        self.trigger.setAttribute('aria-expanded', false);
        $(self.panel).slideUp(duration);

        self.isOpen = false;
    }
}

export default Accordion;
